<div class="mat-comp-wrapper">
  @if (!hideLabel) {
    <div id="label" [class.normalStyle]="normalFontStyle">
      {{label}}
      @if (hasValidtor('require')) {
        <span class="reqIcon" id="require" #require > * </span>
      }
      @if (hasValidtor('info')) {
        <span id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"> ? </span>
      }
    </div>
  }
  <mat-radio-group class="radioGroup" [(ngModel)]="value" [disabled]="disabled" [name]="groupName">
    @for (button of buttonsInfo; track button) {
      <mat-radio-button [value]="button.value">{{button.displayValue}}</mat-radio-button>
    }
  </mat-radio-group>
</div>
